var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69629 19.7435H21.9281V21.6667H2.69629V19.7435ZM2.69629 7.24288L12.3122 2.43494L21.9281 7.24288V11.0892H2.69629V7.24288ZM4.61947 8.4314V9.16606H20.0049V8.4314L12.3122 4.58505L4.61947 8.4314ZM12.3122 8.20447C12.0571 8.20447 11.8126 8.10316 11.6322 7.92282C11.4519 7.74249 11.3506 7.49791 11.3506 7.24288C11.3506 6.98785 11.4519 6.74327 11.6322 6.56293C11.8126 6.3826 12.0571 6.28129 12.3122 6.28129C12.5672 6.28129 12.8118 6.3826 12.9921 6.56293C13.1725 6.74327 13.2738 6.98785 13.2738 7.24288C13.2738 7.49791 13.1725 7.74249 12.9921 7.92282C12.8118 8.10316 12.5672 8.20447 12.3122 8.20447Z",
    fill: "#0D458A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.59375,
    y: 12.0499,
    width: 1.9653,
    height: 6.69197,
    fill: "#3AA64C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.35645,
    y: 12.0499,
    width: 1.9653,
    height: 6.69197,
    fill: "#3AA64C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.293,
    y: 12.0499,
    width: 1.9653,
    height: 6.69197,
    fill: "#3AA64C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.0557,
    y: 12.0499,
    width: 1.9653,
    height: 6.69197,
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankImg);
export default __webpack_public_path__ + "static/media/bankImg.65759a9a423923eeb8281ec5ec549d48.svg";
export { ForwardRef as ReactComponent };